/**
 * Created by shobhitjain on 16/12/19.
 */

import classnames from 'classnames';
import PropTypes from 'prop-types';
import React, { Component } from 'react';
import style from './index.scss';

/*
 * This is a tabView where Provided TabConfig and Data, it will render the
 * TAB List, NOT CONTENT
 *
 * */

class TabListView extends Component {
  constructor(props) {
    super(props);
    this.state = {
      activeIndex: -1
    };
  }

  UNSAFE_componentWillReceiveProps(nextProps) {
    if (nextProps.data && this.state.activeIndex === -1) {
      let initialActiveIndex = -1;
      const { tabConfig, data } = this.props;
      tabConfig.map((tab, index) => {
        if (data[tab.key].length !== 0 && initialActiveIndex === -1) {
          initialActiveIndex = index;
          this.props.onSetActiveIndex(initialActiveIndex);
        }
      });
      this.setState({ activeIndex: initialActiveIndex });
    }
  }

  setActiveIndex = (index) => {
    this.setState({ activeIndex: index });
    this.props.onSetActiveIndex(index);
  };

  render() {
    const { activeIndex } = this.state;
    const { data, tabConfig } = this.props;

    return (
      <div className={classnames(style.card_body)}>
        <ul
          className={classnames(style.tookitaki_pills, style.nav)}
          role="tablist">
          {tabConfig.map((tab, index) => {
            if (data[tab.key].length !== 0) {
              return (
                <Tab
                  setActiveIndex={this.setActiveIndex}
                  title={tab.name}
                  index={index}
                  isDisabled={false}
                  icon={tab.icon}
                  isActive={activeIndex === index}
                />
              );
            } else {
              return (
                <Tab
                  setActiveIndex={this.setActiveIndex}
                  title={tab.name}
                  index={index}
                  isDisabled={true}
                  icon={tab.icon}
                  isActive={false}
                />
              );
            }
          })}
        </ul>
      </div>
    );
  }
}

TabListView.propTypes = {
  tabConfig: PropTypes.array.isRequired,
  data: PropTypes.object.isRequired
};

export default TabListView;

/*
 * This is the tab for Tabbed Table
 * @param isActive if TAB is active
 * @param index determines the index of the tab
 * @param title of the tab
 * @param setActiveIndex is the onClick listener
 * @param isDisabled if tab is disabled by default
 * @param icon determines icon image for tab
 * */
const Tab = ({ isActive, index, title, setActiveIndex, isDisabled, icon }) => {
  return (
    <li className={classnames(style.alert, style.nav_pills_li)}>
      <a
        className={classnames(
          isActive ? style.active : '',
          isDisabled ? style.disabled : '',
          style.nav_link
        )}
        onClick={() => setActiveIndex(index)}>
        <i className={classnames('icon24', icon)} />
        {title}
      </a>
    </li>
  );
};
